<template>
  <fieldset class="rating">
    <template v-for="star in stars">
      <input v-model="rating"
             type="radio"
             :id="star.id"
             name="rating"
             :value="star.value"
             @change="handleRating" />
      <label :class="star.class" :for="star.id"></label>
    </template>
  </fieldset>
</template>

<script>

  import {HTTP} from '../../core/http/http-common';
  import Routing from '../../core/router/router';

  export default {

    name: "rating-stars",
    props: {
      mediaId: {
        type: Number,
        required: true
      },
      mediaType: {
        type: String
      }
    },
    data() {
      return {
        stars: [],
        rating: 0
      }
    },
    computed: {

    },
    methods: {
      handleRating() {
        if(this.mediaId){
          const params = {
            [this.mediaType] : this.mediaId,
            user: this.$cookie.get('uepUserID'),
            vote: this.rating
          };
          HTTP.post(Routing.generate("api_post_vote_by_user_and_" + this.mediaType), params)
            .then(function(response) {
                if (response.data.code === 200) {

                }
              },
              function(error){
              }
            )
        }

      }
    },
    created() {
      for (let i = 5; i > 0; i -= 0.5) {
        const star = {
          id: 'star-'+i,
          value: i,
          class: i % 1 === 0 ? 'full' : 'half'
        };
        this.stars.push(star);
      }
    },
    mounted() {
      var self = this;
      if(this.mediaId){
        HTTP.post(Routing.generate("api_post_avg_user_vote_" + this.mediaType), {[this.mediaType]: this.mediaId})
          .then(function(response) {
              if (response.data.code === 200) {
                self.rating = Math.round(response.data.data.average_vote * 2) / 2;
              }
            },
            function(error){
            }
          )
      }

    }

  }
</script>

<style lang="scss" scoped>
  //colors
  $gray: #ddd;
  $gold: #ffa500;
  $gold-light: #ffd700;

  fieldset {
    margin: 0;
    padding: 0;
    width: 100px;
  }
  label {
    margin: 0;
    padding: 0;
  }
  body {
    margin: 20px;
  }
  h1 {
    font-size: 1.5em;
    margin: 10px;
  }
  .rating {
    border: none;
    float: left;
    > input {
      display: none;
      &:checked {
        ~ label {
          color: $gold;
          &:hover {
            color: $gold-light;
            ~ label {
              color: $gold-light;
            }
          }
        }
        + label:hover {
          color: $gold-light;
        }
      }
    }
    > label {
      color: $gray;
      float: right;
      &:before {
        margin: 0 2px;
        font-size: 1em;
        font-family: 'dark-skin';
        display: inline-block;
        content: "\e91f";
        cursor: pointer;
      }
      &:hover ~ input:checked ~ label {
        color: $gold-light;
      }
    }
    > .half:before {
      content: "\e91e";
      position: absolute;
      margin-left: -1.5px;
    }
    &:not(:checked) > label:hover {
      color: $gold;
      ~ label {
        color: $gold;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/components/RatingStars.vue